import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  background-color: #34a853;
  padding: 16px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  z-index: 1000;

  &:hover {
    opacity: 1;
  }
`;
